import fetch from 'isomorphic-fetch';
import {history} from "../store/store";
import { sessionService } from 'redux-react-session';
import _ from "lodash";
import {LOGOUT, API2_URL, LOGIN_FAIL, LOGIN_USER, FORGOT_OK, LOGIN_REQUEST, LOGIN_OK, LOGIN_AGENCIES, LOGIN_CDMS, FORGOT_REQUEST, RESET_REQUEST, RESET_OK} from "../store/config";
import {validateRegister} from "./register";

export const validateSession = (session = {}) => {
	return dispatch => {
		return dispatch(sessionService.loadSession)
			.then((response) => {
				return saveSession(response)
			})
			.catch((error) => {
				if(!_.isEmpty(session)) {
					return dispatch(fetchUserInfo(session));
				}else {
					dispatch(validateRegister())
					return dispatch(loginFail(''));
				}
			})
	}
}

export const login = (data) => {
	const body = {
		grant_type: "password",
		client_id: "1",
		client_secret: "FzTk5zx5mFpGroBeQvrYqwAZPVVEgt1pQ0kTSsLr",
		username: data.username,
		password: data.password
	};
	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'post',
		body: JSON.stringify(body)
	};

	return dispatch => {
		dispatch(loginRequest());
		return fetch(`${API2_URL}/oauth/token`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => {
					let session = {
						...json,
						remember: data.remember ? true : false
					}
					return dispatch(validateSession(session))
				},
				error => dispatch(loginFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
			);
	}
}

export const recover = (data) => {
	const body = {
		email: data.username,
	}

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'post',
		body: JSON.stringify(body)
	}

	return dispatch => {
		dispatch(recoverRequest());
		return fetch(`${API2_URL}/password/email`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => dispatch(recoverUserData(json)),
				error => dispatch(loginFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
			);
	}
}

export function userReset(data, query) {
	let tmp = query.split("&");
	let token = tmp[1].split("=");
	token = token[1];

	const body = {
		email: data.username,
		token: token,
		password: data.password,
		password_confirmation: data.password_confirmation
	}


	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'post',
		body: JSON.stringify(body)
	}

	return dispatch => {
		dispatch(resetRequest());
		return fetch(`${API2_URL}/password/reset`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => {
					setTimeout(history.push('/'), 1000);
					return dispatch(resetUserData(json));
				},
				error => {
					return dispatch(loginFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
				}
			)
	}
}

export const logout = () => {
	sessionService.deleteSession();
	sessionService.deleteUser();

	return dispatch => {
		dispatch(logoutUserData());
		history.push('/');
	}
}

/*const renew = (token) => {
	const body = {
		client_id: "1",
		client_secret: "FzTk5zx5mFpGroBeQvrYqwAZPVVEgt1pQ0kTSsLr",
		refresh_token: token.refresh_token,
		grant_type: 'refresh_token'
	}

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'post',
		body: JSON.stringify(body)
	}

	return dispatch => {
		return fetch(`${API2_URL}/oauth/token`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => {
					return dispatch(validateSession(json))
				},
				error => {
					dispatch(loginFail(_.values(error)))
					history.push('/');
				}
			);
	}
}*/

const fetchUserInfo = (token) => {
	return dispatch => {
		dispatch(loginRequest());
		return dispatch(fetchUserAgencies(token.access_token))
			.then((agencies) => {
				if(_.isObject(agencies.payload) || _.isArray(agencies.payload)) {
			    	return dispatch(fetchUserCdms(token.access_token))
						.then((cdms) => {
							if(_.isObject(cdms.payload) || _.isArray(cdms.payload)){
								return dispatch(fetchUserProfile(token))
									.then((profile) => {
										if(!_.isEmpty(profile.payload)) {
											return dispatch(fetchUserMenu(token.access_token))
												.then((menu) => {
													if(!_.isEmpty(menu.payload)) {
														return saveSession({agencies:agencies.payload,cdms: cdms.payload,profile:profile.payload, menu:menu.payload, version: menu.version});
													}
												})
										}
									})
							}
						})
				}
			})
	}
}

const fetchUserMenu = (token) => {
	const options = {
		headers: {
			'Accept': 'application/json',
			'Authorization': `Bearer ${token}`
		},
		method: 'get'
	}

	return dispatch => {
		return fetch(`${API2_URL}/profile/menu`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => dispatch(loginUserMenu(json)),
				error => dispatch(loginFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
			)
	}
}

const fetchUserProfile = (token) => {
	const options = {
		headers: {
			'Accept': 'application/json',
			'Authorization': `Bearer ${token.access_token}`
		},
		method: 'get'
	}

	return dispatch => {
		return fetch(`${API2_URL}/profile`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => {
					let profile = {
						...json.data,
						...token
					}
					return dispatch(loginUserProfile(profile))
				},
				error => dispatch(loginFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
			)
	}
}

export const fetchUserAgencies = (token) => {
	const options = {
		headers: {
			'Accept': 'application/json',
			'Authorization': `Bearer ${token}`
		},
		method: 'get'
	}

	return dispatch => {
		return fetch(`${API2_URL}/profile/agencies`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => dispatch(loginUserAgencies(json.data)),
				error => dispatch(loginFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
			)
	}
}

export const fetchUserCdms = (token) => {
	const options = {
		headers: {
			'Accept': 'application/json',
			'Authorization': `Bearer ${token}`
		},
		method: 'get'
	}

	return dispatch => {
		return fetch(`${API2_URL}/profile/cdms`, options)
			.then(result => {
				if (result.status >= 200 && result.status < 300) {
					return result.json();
				} else {
					return result.json().then(Promise.reject.bind(Promise));
				}
			})
			.then(
				json => dispatch(loginUserCdms(json.data)),
				error => dispatch(loginFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
			)
	}
}

/*const setLoginState = (agencies, profile) => {
	return dispatch => {
		dispatch(loginUserAgencies(agencies));
		dispatch(loginUserProfile(profile));
		return dispatch(fetchUserMenu(profile.access_token))
			.then(response => {
				if(response.error) {
					dispatch(loginFail(response.error));
					history.push('/');
				}else{
					return response;
				}
			});
	}
}*/

const saveSession = (session) => {
	sessionService.saveSession(session);
	sessionService.saveUser(session)
		.then(() => {
			if(!_.isEmpty(history.location.state) && !_.isEmpty(history.location.state.from)) {
				history.push(history.location.state.from);
			}else{
				history.push('/inicio');
			}
		})
		.catch(error => console.warn('error', error))
}

const logoutUserData = () => {
	return {
		type: LOGOUT,
		timestamp: Date.now()
	}
}

const loginRequest = () => {
	return {
		type: LOGIN_REQUEST,
		isFetching: true,
		timestamp: Date.now(),
		message: 'Iniciando sesión'
	}
}

const loginFail = (error) => {
	return {
		type: LOGIN_FAIL,
		isFetching: false,
		error: error,
		payload: undefined,
		timestamp: Date.now()
	}
}

const loginUserAgencies = (data) => {
	return {
		type: LOGIN_AGENCIES,
		payload: data,
		message: 'Cargando estados y municipios'
	}
}

const loginUserCdms = (data) => {
	return {
		type: LOGIN_CDMS,
		payload: data,
		message: 'Cargando cdms'
	}
}

export const loginUserProfile = (data) => {
	return {
		type: LOGIN_USER,
		payload: data,
		message: 'Cargando perfil de usuario'
	}
}

const loginUserMenu = (json) => {
	return {
		type: LOGIN_OK,
		isFetching: false,
		payload: json.data,
		version: json.version,
		timestamp: Date.now(),
		message: '¡Bienvenido!'
	}
}

const recoverUserData = (data) => {
	return {
		type: FORGOT_OK,
		isFetching: false,
		payload: data.data.message,
		timestamp: Date.now()
	}
}

const recoverRequest = () => {
	return {
		type: FORGOT_REQUEST,
		isFetching: true,
		payload: 'Buscando tu usuario',
		timestamp: Date.now()
	}
}

const resetRequest = () => {
	return {
		type: RESET_REQUEST,
		isFetching: true,
		payload: 'Guardando cambios',
		timestamp: Date.now()
	}
}

const resetUserData = (data) => {
	return {
		type: RESET_OK,
		isFetching: false,
		payload: data.data.message,
		timestamp: Date.now()
	}
}



// WEBPACK FOOTER //
// ./src/actions/login.js